<template>
    <div class="table-tr">
        <div class="table-td cell-word-review">
            <strong>{{ startAndEndDate }}</strong>
        </div>

        <div class="table-td cell-duration">
            {{ __choice("{0} :days days|{1} :days day|[2,4] :days days|[5,*] :days days", duration, { 'days': duration }) }}
        </div>

        <div class="table-td cell-patient tooltip">
            <div class="profile">
                <UserAvatar :user-info="substitute.coach.user" size="sm" />
                <div class="profile-name">
                    <strong>{{ substitute.coach.user | fullname }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        substitute: {
            type: Object,
            required: true
        }
    },
    computed: {
        startDate() {
            return moment(this.substitute.start_date)
        },
        endDate() {
            return moment(this.substitute.end_date)
        },
        startAndEndDate() {
            const format = []

            format.push(this.startDate.format('D. '))

            if (this.startDate.format('MM') !== this.endDate.format('MM')) {
                format.push(monthNameDeclension(this.startDate.format('M')))
            }

            format.push(' - ')
            format.push(this.endDate.format('D. '))
            format.push(monthNameDeclension(this.endDate.format('M')))
            format.push(this.endDate.format(' YYYY'))

            return format.join('')
        },
        duration() {
            return this.endDate.diff(this.startDate, 'days') + 1
        }
    }
}
</script>
